/**
 * Created by rathompson on 11/12/21
 * File: IAMConstants
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */
import { OBJECT } from '../../common/utils/Utils'

export const IDENTITIES_PERMISSION_SET = 'common_services.access_management'
export const ROLES_PERMISSION_SET = 'common_services.roles'
export const IDP_PERMISSION_SET = 'common_services.identity_federations'

export const SERVER_ERROR_FAIL_TO_REMOVE_LAST_SUPERUSER = 'Cannot remove the last superuser or msp_superuser in TSG'

interface I_IdentityTypes { USER: 'user', GROUP: 'group', SERVICE_ACCOUNT: 'service_account' }
export const IDENTITY_TYPES: I_IdentityTypes = OBJECT.deepFreeze({
  USER: 'user',
  GROUP: 'group',
  SERVICE_ACCOUNT: 'service_account'
})

export const LABEL_USER = 'User'
export const LABEL_SERVICE_ACCOUNT = 'Service Account'
export const LABEL_GROUP = 'Group'

interface I_AccessLevels { NONE: 'none', READ: 'read', WRITE: 'write' }
export const ACCESS_LEVELS: I_AccessLevels = OBJECT.deepFreeze({
  NONE: 'none',
  READ: 'read',
  WRITE: 'write'
})

interface I_CustomRoleFormActions { ADD: 'add', EDIT: 'edit', CLONE: 'clone' }
export const CUSTOM_ROLE_FORM_ACTIONS: I_CustomRoleFormActions = OBJECT.deepFreeze({
  ADD: 'add',
  EDIT: 'edit',
  CLONE: 'clone'
})

interface I_FedOwnerStatus { PENDING: 'pending', VERIFIED: 'verified', WARNING: 'verified_warning' }
export const IDP_OWNER_STATUS: I_FedOwnerStatus = OBJECT.deepFreeze({
  PENDING: 'pending',
  VERIFIED: 'verified',
  WARNING: 'verified_warning'
})

interface I_FedOwnerStatusTypes { DNS_TEXT: 'dns_txt', OWNER_GRANT: 'owner_grant' }
export const IDP_OWNER_TYPES: I_FedOwnerStatusTypes = OBJECT.deepFreeze({
  DNS_TEXT: 'dns_txt',
  OWNER_GRANT: 'owner_grant',
})
